import React from 'react'
import { Route, Routes } from 'react-router-dom'
import MasterTemplate from '../semulator/pages/MasterTemplate'
import Dashboard from '../semulator/pages/Dashboard'
import Smtp from '../semulator/pages/smtp/Smtp'
import AddSmtp from '../semulator/pages/smtp/AddSmtp'
import EditSmtp from '../semulator/pages/smtp/EditSmtp'
import UserGroup from '../semulator/pages/user-group/UserGroup'
import AssignUser from '../semulator/pages/user-group/AssignUser'
import EmailList from '../semulator/pages/email-template/EmailList'
import AddEmail from '../semulator/pages/email-template/AddEmail'
import EditEmail from '../semulator/pages/email-template/EditEmail'
import LandingPage from '../semulator/pages/landing-page/LandingPage'
import AddLandingPage from '../semulator/pages/landing-page/AddLandingPage'
import EditLandingPage from '../semulator/pages/landing-page/EditLandingPage'
import Campaign from '../semulator/pages/campaign/Campaign'
import AddCampaign from '../semulator/pages/campaign/AddCampaign'
import Users from '../semulator/pages/users/Users'
import AddUsers from '../semulator/pages/users/AddUsers'
import EditUser from '../semulator/pages/users/EditUser'
import ViewCampaign from '../semulator/pages/campaign/ViewCampaign'
import ImportedUsers from '../semulator/pages/users/ImportedUsers'
import ToolSetting from '../semulator/pages/tool-setting/ToolSetting'
import LmsLearnersGroup from '../semulator/pages/learners-group/LmsLearnersGroup'
import Download from '../semulator/pages/download/Download'
import UserCamp from '../semulator/pages/users/UserCamp'
import Offender from '../semulator/pages/offender/Offender'
import OffenderCampDetails from '../semulator/pages/offender/OffenderCampDetails'
import CampaignDownload from '../semulator/pages/download/campaign-download/CampaignDownload'
import OffenderDownload from '../semulator/pages/download/offender-download/OffenderDownload'
import DeletedReport from '../semulator/pages/deleted-report/DeletedReport'
import DeletedCampaign from '../semulator/pages/deleted-report/deleted-campaign/DeletedCampaign'
import DeletedOffender from '../semulator/pages/deleted-report/deleted-offender/DeletedOffender'
import ViewGroup from '../semulator/pages/user-group/ViewGroup'
import Setting from '../semulator/pages/setting/Setting'
import DepartmentHeatmap from '../semulator/pages/analytics/DepartmentHeatmap'
import HumanRiskScoreCard from '../semulator/pages/analytics/HumanRiskScoredCard'
import ThemeMedia from '../semulator/pages/media/ThemeMedia'
import ViewCampaignDownload from '../semulator/pages/download/campaign-download/ViewCampaignDownload'

function SemulatorRoutes() {
  return (
    <Routes>
      <Route path="/" element={<MasterTemplate />}>
        <Route index element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="users-camp/:user_id" element={<UserCamp />} />
        <Route path="imported-users/:tracking_id?" element={<ImportedUsers />} />
        <Route path="add-user" element={<AddUsers />} />
        <Route path="edit-user/:id" element={<EditUser />} />
        <Route path="user-group" element={<UserGroup />} />
        <Route path="assign-user/:id" element={<AssignUser />} />
        <Route path="view-group/:id" element={<ViewGroup />} />
        <Route path="learners-group" element={<LmsLearnersGroup />} />
        <Route path="email-template" element={<EmailList />} />
        <Route path="add-email" element={<AddEmail />} />
        <Route path="edit-email/:id" element={<EditEmail />} />
        <Route path="landing-page" element={<LandingPage />} />
        <Route path="add-landingpage" element={<AddLandingPage />} />
        <Route path="edit-landingpage/:id" element={<EditLandingPage />} />
        <Route path="smtp" element={<Smtp />} />
        <Route path="add-smtp" element={<AddSmtp />} />
        <Route path="edit-smtp/:id" element={<EditSmtp />} />
        <Route path="campaign" element={<Campaign />} />
        <Route path="add-campaign" element={<AddCampaign />} />
        <Route path="view-campaign/:id" element={<ViewCampaign />} />
        <Route path="offender" element={<Offender />} />
        <Route path="offender-camp-details/:user_id" element={<OffenderCampDetails />} />
        <Route path="media" element={<ThemeMedia />} />
        <Route path="view-download-report-campaign" element={<ViewCampaignDownload />} />


        <Route path="downloads" element={<Download />}>
          <Route path="campaign-download" element={<CampaignDownload />} />
          <Route path="offender-download" element={<OffenderDownload />} />


        </Route>

        <Route path="deleted-report" element={<DeletedReport />}>
          <Route path="deleted-campaign" element={<DeletedCampaign />} />
          <Route path="deleted-offender" element={<DeletedOffender />} />
        </Route>

        {/* <Route path="download" element={<Download />} /> */}
        <Route path="tool-setting" element={<ToolSetting />} />
        <Route path="setting" element={<Setting />} />
        <Route path="department-heatmap" element={<DepartmentHeatmap />} />
        <Route path="human-risk-scorecard" element={<HumanRiskScoreCard />} />
      </Route>
    </Routes>
  )
}

export default SemulatorRoutes
